function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.50531 60.0381C-1.15096 55.8988 -0.759414 49.5793 3.37986 45.923L52.5332 2.50531C56.6724 -1.15096 62.992 -0.759414 66.6482 3.37986L110.066 52.5332C113.722 56.6724 113.331 62.992 109.191 66.6482L60.0381 110.066C55.8988 113.722 49.5793 113.331 45.923 109.191L2.50531 60.0381Z",
  fill: "url(#paint0_linear)"
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 0,
  y1: 84.4284,
  x2: 0,
  y2: 84.4284,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#0AA8B3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#8DE1CF"
})));

var SvgValuePropRectangle = function SvgValuePropRectangle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 113,
    viewBox: "0 0 113 113",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgValuePropRectangle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ValuePropRectangle.aa357212.svg";
export { ForwardRef as ReactComponent };